import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useFileDialog } from '@vueuse/core';
import { FileType } from '~/core/enums';
import { WEB_ALLOWED_IMAGE_TYPE_LIST } from '~/core/constants';
import { convertHeicToJpeg, compressImageWithBreakpoints } from '~/core/functions';
import { CONTAINER_WIDTH } from '~/core/constants';
export default defineComponent({
  name: 'BottomSheetUpload',
  props: {
    galleryAccept: {
      type: String,
      default: '*'
    },
    value: {
      type: Boolean,
      default: false
    },
    /**
     * Позволяет конвертировать все загружаемые heic и heif в jpeg
     * */
    convertHeics: {
      type: Boolean,
      default: false
    },
    /**
     * Позволяет уменьшать размер всех загружаемых изображений
     * */
    compressImages: {
      type: Boolean,
      default: false
    }
  },
  emits: ['upload', 'input'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var lazyValue = ref(false);
    var isProcessing = ref(false);
    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException;
    var _useFileDialog = useFileDialog({
        accept: 'image/*',
        capture: 'user'
      }),
      cameraFiles = _useFileDialog.files,
      cameraOpen = _useFileDialog.open,
      cameraReset = _useFileDialog.reset;
    var _useFileDialog2 = useFileDialog({
        accept: props.galleryAccept
      }),
      galleryFiles = _useFileDialog2.files,
      galleryOpen = _useFileDialog2.open,
      galleryReset = _useFileDialog2.reset;
    watch(function () {
      return props.value;
    }, function (val) {
      return val ? show() : hide();
    }, {
      immediate: true
    });
    watchEffect(function () {
      var _cameraFiles$value;
      if (cameraFiles && (_cameraFiles$value = cameraFiles.value) !== null && _cameraFiles$value !== void 0 && _cameraFiles$value.length) {
        emitUpload(cameraFiles.value);
        cameraReset();
      }
    });
    watchEffect(function () {
      var _galleryFiles$value;
      if (galleryFiles && (_galleryFiles$value = galleryFiles.value) !== null && _galleryFiles$value !== void 0 && _galleryFiles$value.length) {
        emitUpload(galleryFiles.value);
        galleryReset();
      }
    });
    function show() {
      lazyValue.value = true;
    }
    function hide() {
      lazyValue.value = false;
    }
    function processImages(files) {
      return Promise.all(files.map(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
          var convertedFile;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (!(props.convertHeics && (file.type === FileType.Heic || file.type === FileType.Heif))) {
                  _context.next = 10;
                  break;
                }
                _context.next = 4;
                return convertHeicToJpeg(file);
              case 4:
                convertedFile = _context.sent;
                if (!props.compressImages) {
                  _context.next = 9;
                  break;
                }
                _context.next = 8;
                return compressImageWithBreakpoints(convertedFile);
              case 8:
                return _context.abrupt("return", _context.sent);
              case 9:
                return _context.abrupt("return", convertedFile);
              case 10:
                if (!(props.compressImages && WEB_ALLOWED_IMAGE_TYPE_LIST.includes(file.type))) {
                  _context.next = 14;
                  break;
                }
                _context.next = 13;
                return compressImageWithBreakpoints(file);
              case 13:
                return _context.abrupt("return", _context.sent);
              case 14:
                _context.next = 19;
                break;
              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", file);
              case 19:
                return _context.abrupt("return", file);
              case 20:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 16]]);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()));
    }
    function emitUpload(_x2) {
      return _emitUpload.apply(this, arguments);
    }
    function _emitUpload() {
      _emitUpload = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        var files;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              files = Array.from(val);
              _context2.prev = 1;
              isProcessing.value = true;
              _context2.next = 5;
              return processImages(files);
            case 5:
              files = _context2.sent;
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              $captureException(_context2.t0, {
                method: 'emitUpload',
                component: 'BottomSheetUpload'
              });
            case 11:
              _context2.prev = 11;
              emit('upload', files);
              hide();
              emit('input', false);
              isProcessing.value = false;
              return _context2.finish(11);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8, 11, 17]]);
      }));
      return _emitUpload.apply(this, arguments);
    }
    function emitInput(val) {
      emit('input', val);
    }
    expose({
      show: show,
      hide: hide
    });
    return {
      CONTAINER_WIDTH: CONTAINER_WIDTH,
      isProcessing: isProcessing,
      lazyValue: lazyValue,
      cameraOpen: cameraOpen,
      galleryOpen: galleryOpen,
      show: show,
      emitInput: emitInput
    };
  }
});